import { ComponentPropsWithoutRef } from 'react';
import { twMerge } from 'tailwind-merge';

interface RowProps extends ComponentPropsWithoutRef<'div'> {}

const Row = (props: RowProps) => {
    const { className = '', children, ...rest } = props;

    return (
        <div className={twMerge('grid grid-cols-12 gap-8', className)} {...rest}>
            {children}
        </div>
    );
};

const RowTitle = (props: RowProps) => {
    const { className = '', children, ...rest } = props;

    return (
        <div className={twMerge('col-span-3 text-gray-400', className)} {...rest}>
            {children}
        </div>
    );
};

const RowValue = (props: RowProps) => {
    const { className = '', children, ...rest } = props;

    return (
        <div className={twMerge('col-span-9 flex justify-between gap-2', className)} {...rest}>
            {children}
        </div>
    );
};

const Root = Row;
const Title = RowTitle;
const Value = RowValue;

export {
    Row,
    RowTitle,
    RowValue,
    //
    Root,
    Title,
    Value,
};
